import { useTranslation } from 'react-i18next';
import { Features, UserQuery } from '../../generated/hooks';
import { FC } from 'react';
import { SortOption, Topics } from '../../components/ConversationSubjects/Topics';
import { usePath } from '@arnold/common';
import { useFeatureFlag } from '../../lib/helpers/hooks';
import { isPulserTopicGroup } from '../../lib/helpers/pulser';

interface IProps {
  user: UserQuery['user'];
}

const ConversationSubjectsScreen: FC<IProps> = ({ user }) => {
  const { t } = useTranslation('surveysOverview');
  const hasPulserModule = useFeatureFlag(Features.PulserModule);

  const { createSurveyPath, surveysPath } = usePath();

  return (
    <Topics
      breadcrumbItems={[{ title: t('AuthorizedPage:standaloneSurveys'), link: surveysPath.createPath() }]}
      heading={t('chooseSurveyTopic')}
      dataIcom="heading-topics"
      user={user}
      hideCreateTopicButton={true}
      defaultSortOption={SortOption.GROUP_BY_CATEGORY}
      actionButtonText={t('topicOverview:planTopic')}
      actionButtonOnClick={(tg) => {
        createSurveyPath.toFunc(tg.id!, tg.name);
      }}
      requireValidForAction={true}
      filterTopicGroups={(topicGroup) =>
        !topicGroup.containsSteps && !(hasPulserModule && isPulserTopicGroup(topicGroup))
      }
    />
  );
};

export default ConversationSubjectsScreen;
